import { useEffect, useRef, useState } from "react";
import { Dropdown, Modal, OverlayTrigger } from "react-bootstrap";
import TooltipCustom from "react-bootstrap/Tooltip";
import { TOKEN_USDT, TOKEN_ETH, CHAIN_TO_TOKEN_ADDRESSES, AQUA_SWAP_TX_STATUS, aquaTokens, aquaChains, CHAIN_BSC, TOKEN_BNB, CHAIN_ARBITRUM, CHAIN_TO_TOKEN_MIN_AMOUNT, AQUA_WALLET_TIME_EXPIRE, DARK_THEME, DEFAULT_TOKEN, DEFAULT_CHAIN, TOKEN_RAIN, TOKEN_BTC, lockedChainTokens, CHAIN_BITCOIN } from "../utils/constants";
import { useTranslation } from "react-i18next";
import { IS_AQUA_SWAP_DEPOSIT_ACTIVE, usdt_token } from "../utils/Enviroment";
import { aquaSwapWalletGeneration } from "../utils/services";
import { notifyError, notifySuccess, notifyWarning } from "./Toast";
import { useGetAllBalances } from "./AllBalances";
import { useTheme } from "../contexts/ThemeProvider";
import { convertMsToMin, getChainByKey, getTokenByKey } from "../utils/helpers";
import { useSocketEvents } from "../hooks/dataFetcher/AquaSocket";
import { DEFAULT_ERROR_HEADING, ERROR_GENERATING_BTC_ADDRESS, ERROR_GENERATING_DEPOSIT_ADDRESS, FUNDS_RECIEVED_SUCCESS, SWAP_FINALIZED_WARNING, SWAP_PROCESSING_WARNING, SWAP_REFUND_WARNING } from "../utils/ConstantMessages";
import GlobalModal from "./GlobalModal/GlobalModal";
import { useEoaAccount } from "../hooks/useEoaAccount";

export const DepositViaWalletOrAddress = ({ show, handleClose, ShowDepositAddressModal, ShowDeposiAccountModal, smartAccount }) => {
    const { t } = useTranslation();
    return (
        <Modal
            className="common-modal-style wallet-modal fundmodal"
            show={show}
            onHide={handleClose}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>{t("Deposit")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="wallet-options">
                    <div className="option-box"
                        id="btn-deposit-connected-wallet"
                        onClick={() => {
                            ShowDeposiAccountModal(true);
                        }}
                    >
                        <div className="left-side">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
                                <path d="M22.1667 8.66667V5.16667C22.1667 4.85725 22.0437 4.5605 21.825 4.34171C21.6062 4.12292 21.3094 4 21 4H5.83333C5.21449 4 4.621 4.24583 4.18342 4.68342C3.74583 5.121 3.5 5.71449 3.5 6.33333C3.5 6.95217 3.74583 7.54566 4.18342 7.98325C4.621 8.42083 5.21449 8.66667 5.83333 8.66667H23.3333C23.6427 8.66667 23.9395 8.78958 24.1583 9.00838C24.3771 9.22717 24.5 9.52391 24.5 9.83333V14.5M24.5 14.5H21C20.3812 14.5 19.7877 14.7458 19.3501 15.1834C18.9125 15.621 18.6667 16.2145 18.6667 16.8333C18.6667 17.4522 18.9125 18.0457 19.3501 18.4832C19.7877 18.9208 20.3812 19.1667 21 19.1667H24.5C24.8094 19.1667 25.1062 19.0438 25.325 18.825C25.5437 18.6062 25.6667 18.3094 25.6667 18V15.6667C25.6667 15.3572 25.5437 15.0605 25.325 14.8417C25.1062 14.6229 24.8094 14.5 24.5 14.5Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3.5 6.33337V22.6667C3.5 23.2855 3.74583 23.879 4.18342 24.3166C4.621 24.7542 5.21449 25 5.83333 25H23.3333C23.6428 25 23.9395 24.8771 24.1583 24.6583C24.3771 24.4395 24.5 24.1428 24.5 23.8334V19.1667" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <h6>{t("Via connected wallet")}</h6>
                            <p>{smartAccount?.slice(0, 5)}...{smartAccount?.slice(-3)}</p>
                        </div>
                        <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                            <path d="M19.0489 11.9868L12.8614 18.1743C12.7324 18.3033 12.5574 18.3758 12.375 18.3758C12.1926 18.3758 12.0176 18.3033 11.8886 18.1743C11.7596 18.0453 11.6871 17.8703 11.6871 17.6879C11.6871 17.5054 11.7596 17.3305 11.8886 17.2015L16.903 12.1879L3.4375 12.1879C3.25516 12.1879 3.0803 12.1155 2.95136 11.9865C2.82243 11.8576 2.75 11.6827 2.75 11.5004C2.75 11.318 2.82243 11.1432 2.95136 11.0142C3.0803 10.8853 3.25516 10.8129 3.4375 10.8129L16.903 10.8129L11.8886 5.79929C11.7596 5.67029 11.6871 5.49532 11.6871 5.31288C11.6871 5.13044 11.7596 4.95548 11.8886 4.82648C12.0176 4.69747 12.1926 4.625 12.375 4.625C12.5574 4.625 12.7324 4.69747 12.8614 4.82648L19.0489 11.014C19.1128 11.0778 19.1635 11.1537 19.1981 11.2371C19.2327 11.3206 19.2505 11.41 19.2505 11.5004C19.2505 11.5907 19.2327 11.6802 19.1981 11.7637C19.1635 11.8471 19.1128 11.9229 19.0489 11.9868Z" fill="#7A7A7A" />
                        </svg>
                    </div>
                    <div className="option-box"
                        id="btn-deposit-address"
                        onClick={() => {
                            ShowDepositAddressModal(true);
                            handleClose();
                        }}
                    >
                        <div className="left-side">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
                                <path d="M21.0002 19.1667C21.0002 17.878 19.9555 16.8334 18.6668 16.8334C17.3782 16.8334 16.3335 17.878 16.3335 19.1667V21.5C16.3335 22.7887 17.3782 23.8334 18.6668 23.8334C19.9555 23.8334 21.0002 22.7887 21.0002 21.5V19.1667Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.6667 7.49996C11.6667 6.21129 10.622 5.16663 9.33333 5.16663C8.04467 5.16663 7 6.21129 7 7.49996V9.83329C7 11.122 8.04467 12.1666 9.33333 12.1666C10.622 12.1666 11.6667 11.122 11.6667 9.83329V7.49996Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7 23.8334H11.6667" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7 16.8334H9.33333V23.8334" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M22 5.33313L15.333 12.0001" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15.333 5.33313L22 12.0001" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <h6>{t("Via deposit address")}</h6>
                            <p>{t("No Limit - Instant")}</p>
                        </div>
                        <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                            <path d="M19.0489 11.9868L12.8614 18.1743C12.7324 18.3033 12.5574 18.3758 12.375 18.3758C12.1926 18.3758 12.0176 18.3033 11.8886 18.1743C11.7596 18.0453 11.6871 17.8703 11.6871 17.6879C11.6871 17.5054 11.7596 17.3305 11.8886 17.2015L16.903 12.1879L3.4375 12.1879C3.25516 12.1879 3.0803 12.1155 2.95136 11.9865C2.82243 11.8576 2.75 11.6827 2.75 11.5004C2.75 11.318 2.82243 11.1432 2.95136 11.0142C3.0803 10.8853 3.25516 10.8129 3.4375 10.8129L16.903 10.8129L11.8886 5.79929C11.7596 5.67029 11.6871 5.49532 11.6871 5.31288C11.6871 5.13044 11.7596 4.95548 11.8886 4.82648C12.0176 4.69747 12.1926 4.625 12.375 4.625C12.5574 4.625 12.7324 4.69747 12.8614 4.82648L19.0489 11.014C19.1128 11.0778 19.1635 11.1537 19.1981 11.2371C19.2327 11.3206 19.2505 11.41 19.2505 11.5004C19.2505 11.5907 19.2327 11.6802 19.1981 11.7637C19.1635 11.8471 19.1128 11.9229 19.0489 11.9868Z" fill="#7A7A7A" />
                        </svg>
                    </div>
                </div>
            </Modal.Body>
        </Modal>)
}

export const DepositViaAddress = ({ show, setShow, handleClose, QrCodeSize, UsdtLogoSize, QRCodeCanvas, smartAccount, isCopied, handleCopy, setSelectedToken, selectedToken, setSelectedChain, selectedChain }) => {
    const { t } = useTranslation();
    const [addressLoading, setAddressLoading] = useState(false);
    const [showDynamic, setShowDynamic] = useState(false);
    const [aquaSwapAddress, setAquaSwapAddress] = useState('');
    const [btcRefundAddress, setBtcRefundAddress] = useState('');
    const [aquaEvents, setAquaEvents] = useState([]);
    const [minDepositAmount, setMinDepositAmount] = useState("--");
    const getAllBalances = useGetAllBalances();
    let { account } = useEoaAccount();
    const aquaTimeout = useRef(null);
    const handleShow = () => {
        if (isBtcSelected) {
            const btcRegex = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/;
            const isValidBTCAddress = btcRegex.test(btcRefundAddress)
            if (!isValidBTCAddress) {
                notifyError(DEFAULT_ERROR_HEADING, ERROR_GENERATING_BTC_ADDRESS);
                return;
            } else {
                setShowDynamic(true);
                handleClose()
            }
        } else {
            setShowDynamic(true);
            handleClose()
        }
    };
    const isBtcSelected = selectedToken === TOKEN_BTC;

    const chainSelected = getChainByKey(selectedToken === TOKEN_RAIN ? CHAIN_ARBITRUM : isBtcSelected ? CHAIN_BITCOIN : selectedToken === TOKEN_BNB ? CHAIN_BSC : selectedChain)
    const tokenSelected = aquaTokens.find(t =>
        selectedChain === DEFAULT_CHAIN ? t.key === selectedToken :
            selectedChain === CHAIN_BSC && selectedToken === TOKEN_ETH ? t.key === TOKEN_BNB :
                selectedChain !== CHAIN_BSC && selectedToken === TOKEN_BNB ? t.key === TOKEN_ETH : t.key === selectedToken);

    useSocketEvents(aquaEvents);

    const handleAquaSwapWallet = async (Token, chain) => {
        if (!smartAccount && !tokenSelected && !chainSelected) return

        const shiftToken = (Token?.key === TOKEN_ETH && chain?.key === CHAIN_BSC) ? getTokenByKey(TOKEN_BNB) : Token?.key === TOKEN_BNB && chain?.key !== CHAIN_BSC ? getTokenByKey(TOKEN_ETH) : Token
        const userSelectToken = Token?.key ? shiftToken : tokenSelected
        const userSelectedChain = chain?.key ? chain : chainSelected
        setMinDepositAmount(CHAIN_TO_TOKEN_MIN_AMOUNT[userSelectedChain?.key?.toUpperCase()]?.[userSelectToken?.key?.toUpperCase()])
        if ((userSelectToken?.key === TOKEN_USDT && userSelectedChain?.key === CHAIN_ARBITRUM) || (userSelectToken?.key === TOKEN_RAIN && userSelectedChain?.key === CHAIN_ARBITRUM)) {
            setShow(true);
            setShowDynamic(false)
            setAquaSwapAddress(smartAccount)
            return
        }
        const keyToAddress = CHAIN_TO_TOKEN_ADDRESSES[userSelectedChain?.key?.toUpperCase()]?.[userSelectToken?.key?.toUpperCase()];
        const payload = {
            walletAddress: smartAccount,
            sourceChain: userSelectedChain?.key.toLowerCase(),
            destinationChain: "arbitrum",
            sourceTokenAddress: keyToAddress,
            destinationTokenAddress: usdt_token,
            recipientAddress: smartAccount,
            refundWalletAddress: isBtcSelected ? btcRefundAddress : account,
        }
        try {
            setAddressLoading(true)
            setShow(true);
            setShowDynamic(false)
            const aquaSwapRes = await aquaSwapWalletGeneration(payload)
            if (aquaSwapRes) {
                const aquaSwapFilteredRes = aquaSwapRes?.existingRequest ? aquaSwapRes?.existingRequest : aquaSwapRes
                const events = [
                    {
                        eventName: "connect",
                        handler: () => console.log("Connected to the server"),
                    },
                    {
                        eventName: aquaSwapFilteredRes?.listener_key,
                        handler: (data) => {
                            console.log('Socket data: ', data)
                            if (data?.data?.min_amount) {
                                console.log('Tx min amount:', data?.data?.min_amount)
                                notifyWarning(`Minumum deposit amount is ${data?.data?.min_amount}. Please deposit equal or more than this amount.`)
                            }
                            if (data?.status === AQUA_SWAP_TX_STATUS?.IN_SWAP) {
                                console.log(data?.status)
                                notifyWarning(SWAP_PROCESSING_WARNING)
                            }
                            if (data?.status === AQUA_SWAP_TX_STATUS?.FINALIZED) {
                                console.log(data?.status)
                                setTimeout(async () => {
                                    await getAllBalances()
                                }, 6000);
                                notifyWarning(SWAP_FINALIZED_WARNING)
                                setAquaSwapAddress('')
                            }
                            if (data?.status === AQUA_SWAP_TX_STATUS?.REFUNDED) {
                                console.log(data?.status)
                                handleClose()
                                setAquaSwapAddress('')
                                notifyError(DEFAULT_ERROR_HEADING, SWAP_REFUND_WARNING)
                            }
                            if (data.status === AQUA_SWAP_TX_STATUS?.COMPLETED && data?.tx) {
                                console.log(data?.status)
                                console.log('data?.tx: ', data?.tx)
                                setTimeout(async () => {
                                    await getAllBalances()
                                }, 6000);
                                handleClose()
                                setAquaSwapAddress('')
                                setSelectedChain(CHAIN_ARBITRUM)
                                setSelectedToken(TOKEN_USDT)
                                notifySuccess(FUNDS_RECIEVED_SUCCESS)
                            }
                        },
                    }
                ]
                setAquaEvents(events);
                setAquaSwapAddress(aquaSwapFilteredRes?.assignedWalletAddress)
                setAddressLoading(false)
                if (aquaTimeout.current) {
                    clearTimeout(aquaTimeout.current);
                }

                aquaTimeout.current = setTimeout(() => {
                    setAquaSwapAddress("");
                }, AQUA_WALLET_TIME_EXPIRE);
            }
            else {
                notifyError(DEFAULT_ERROR_HEADING, isBtcSelected ? ERROR_GENERATING_BTC_ADDRESS : ERROR_GENERATING_DEPOSIT_ADDRESS)
                setAddressLoading(false)
            }
        } catch (error) {
            setAddressLoading(false)
            addressLoading(false)
            console.error('Error fetching aqua swap wallet:', error);
        }
    }

    const showGenerateButton =
        isBtcSelected
            ? !!btcRefundAddress && !aquaSwapAddress
            : (
                !aquaSwapAddress &&
                tokenSelected?.key !== DEFAULT_TOKEN &&
                chainSelected?.key !== DEFAULT_CHAIN
            );


    return (
        <>
            <GlobalModal showDynamic={showDynamic} setShowDynamic={setShowDynamic} dynamicText={`This request applies to one swap only and will remain valid for ${convertMsToMin(AQUA_WALLET_TIME_EXPIRE)} minutes. For further swaps, please initiate a new request.`} handleAquaSwapWallet={() => handleAquaSwapWallet()} />
            <Modal
                className="common-modal-style wallet-modal fundmodal"
                show={show}
                onHide={() => { handleClose(); setAquaSwapAddress(''); setSelectedChain(DEFAULT_CHAIN); setSelectedToken(TOKEN_USDT) }}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}
                        onClick={() => { handleClose(); setAquaSwapAddress(''); setSelectedChain(DEFAULT_CHAIN); setSelectedToken(TOKEN_USDT) }}
                    ><svg style={{ flexShrink: "0" }} xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                            <path d="M2.41453 9.10172L7.47703 4.03922C7.58258 3.93367 7.72573 3.87437 7.875 3.87437C8.02427 3.87437 8.16742 3.93367 8.27297 4.03922C8.37852 4.14477 8.43781 4.28792 8.43781 4.43719C8.43781 4.58645 8.37852 4.72961 8.27297 4.83515L4.17024 8.93719L15.1875 8.93719C15.3367 8.93719 15.4798 8.99645 15.5852 9.10194C15.6907 9.20743 15.75 9.3505 15.75 9.49969C15.75 9.64887 15.6907 9.79195 15.5852 9.89743C15.4798 10.0029 15.3367 10.0622 15.1875 10.0622L4.17024 10.0622L8.27297 14.1642C8.37852 14.2698 8.43781 14.4129 8.43781 14.5622C8.43781 14.7115 8.37852 14.8546 8.27297 14.9602C8.16742 15.0657 8.02427 15.125 7.875 15.125C7.72573 15.125 7.58258 15.0657 7.47703 14.9602L2.41453 9.89766C2.36223 9.84541 2.32074 9.78338 2.29244 9.71509C2.26413 9.6468 2.24956 9.57361 2.24956 9.49969C2.24956 9.42576 2.26413 9.35257 2.29244 9.28428C2.32074 9.216 2.36223 9.15396 2.41453 9.10172Z" fill="white" />
                        </svg>{t("Via deposit address")}</Modal.Title>
                </Modal.Header>
                {IS_AQUA_SWAP_DEPOSIT_ACTIVE ?
                    <Modal.Body>
                        {/* <p className="para">Please select the desired asset and chain for deposit</p> */}
                        <h6 className="swap-text">
                            Choose the asset you wish to swap to <img src="\assets\usdt-iconwitharb.svg" alt="img" className="img-fluid" /> USDT <span>(Arbitrum)</span>
                        </h6>
                        <div className="mainboxes">
                            <div className="innermainbox">
                                <p className="innerpara">{t("Token")}</p>
                                <Dropdown className="dropdowntokenitems">
                                    <Dropdown.Toggle
                                        id="dropdownMenuButton1"
                                        className="d-flex align-items-center"
                                        disabled={addressLoading}
                                    >
                                        <div className="left-item d-flex align-items-center">
                                            {tokenSelected?.key != DEFAULT_TOKEN &&
                                                <img
                                                    src={tokenSelected?.icon}
                                                    alt="img"
                                                    className="img-fluid me-2"
                                                />}
                                            {tokenSelected?.key}
                                        </div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="14"
                                            viewBox="0 0 12 14"
                                            fill="none"
                                            className="ms-2"
                                        >
                                            <path
                                                d="M5.60172 13.5855L0.539218 8.52297C0.43367 8.41742 0.374373 8.27427 0.374373 8.125C0.374373 7.97573 0.43367 7.83258 0.539218 7.72703C0.644766 7.62148 0.787919 7.56219 0.937187 7.56219C1.08645 7.56219 1.22961 7.62148 1.33516 7.72703L5.43719 11.8298L5.43719 0.8125C5.43719 0.663315 5.49645 0.520241 5.60194 0.414752C5.70743 0.309263 5.8505 0.25 5.99969 0.25C6.14887 0.25 6.29195 0.309263 6.39743 0.414752C6.50292 0.520242 6.56219 0.663315 6.56219 0.8125L6.56219 11.8298L10.6642 7.72703C10.7698 7.62148 10.9129 7.56219 11.0622 7.56219C11.2115 7.56219 11.3546 7.62148 11.4602 7.72703C11.5657 7.83258 11.625 7.97573 11.625 8.125C11.625 8.27427 11.5657 8.41742 11.4602 8.52297L6.39766 13.5855C6.34541 13.6378 6.28338 13.6793 6.21509 13.7076C6.1468 13.7359 6.07361 13.7504 5.99969 13.7504C5.92577 13.7504 5.85257 13.7359 5.78428 13.7076C5.716 13.6793 5.65396 13.6378 5.60172 13.5855Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        {aquaTokens?.slice(1)?.map((token) => (
                                            <Dropdown.Item
                                                key={token?.key}
                                                onClick={() => {
                                                    setSelectedToken(token?.key);
                                                    setSelectedChain(DEFAULT_CHAIN)
                                                    setAquaSwapAddress('')
                                                    setMinDepositAmount("--")
                                                }}
                                            >
                                                <img
                                                    src={token?.icon}
                                                    alt="innertokenimg"
                                                    className="innertokenimg me-2"
                                                />
                                                {t(token?.key)}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <div className="innermainbox">
                                <p className="innerpara">{t("Chain")}</p>
                                <Dropdown className="dropdowntokenitems">
                                    <Dropdown.Toggle
                                        id="dropdownMenuButton1"
                                        className="d-flex align-items-center"
                                        disabled={addressLoading || lockedChainTokens?.includes(selectedToken) ? true : false}
                                    >
                                        <div className="left-item d-flex align-items-center">
                                            {chainSelected?.key != DEFAULT_CHAIN &&
                                                <img
                                                    src={chainSelected?.icon}
                                                    alt="innertokenimg"
                                                    className="innertokenimg me-2"
                                                />}
                                            {chainSelected?.label}
                                        </div>
                                        {
                                            !lockedChainTokens?.includes(selectedToken) && (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="14"
                                                    viewBox="0 0 12 14"
                                                    fill="none"
                                                    className="ms-2"
                                                >
                                                    <path
                                                        d="M5.60172 13.5855L0.539218 8.52297C0.43367 8.41742 0.374373 8.27427 0.374373 8.125C0.374373 7.97573 0.43367 7.83258 0.539218 7.72703C0.644766 7.62148 0.787919 7.56219 0.937187 7.56219C1.08645 7.56219 1.22961 7.62148 1.33516 7.72703L5.43719 11.8298L5.43719 0.8125C5.43719 0.663315 5.49645 0.520241 5.60194 0.414752C5.70743 0.309263 5.8505 0.25 5.99969 0.25C6.14887 0.25 6.29195 0.309263 6.39743 0.414752C6.50292 0.520242 6.56219 0.663315 6.56219 0.8125L6.56219 11.8298L10.6642 7.72703C10.7698 7.62148 10.9129 7.56219 11.0622 7.56219C11.2115 7.56219 11.3546 7.62148 11.4602 7.72703C11.5657 7.83258 11.625 7.97573 11.625 8.125C11.625 8.27427 11.5657 8.41742 11.4602 8.52297L6.39766 13.5855C6.34541 13.6378 6.28338 13.6793 6.21509 13.7076C6.1468 13.7359 6.07361 13.7504 5.99969 13.7504C5.92577 13.7504 5.85257 13.7359 5.78428 13.7076C5.716 13.6793 5.65396 13.6378 5.60172 13.5855Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            )
                                        }
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        {aquaChains?.filter((chain) => selectedToken === TOKEN_ETH ? chain.key !== CHAIN_BSC && chain.key !== CHAIN_BITCOIN : chain.key
                                        )?.slice(1, 5)?.map((chain) => (
                                            <Dropdown.Item
                                                key={chain.key}
                                                onClick={() => {
                                                    setSelectedChain(chain.key);
                                                    setMinDepositAmount("--")
                                                    setAquaSwapAddress('')
                                                }}
                                                disabled={selectedToken === TOKEN_RAIN && chain.key !== CHAIN_ARBITRUM ? true : false}
                                            >
                                                <img
                                                    src={chain.icon}
                                                    alt="innertokenimg"
                                                    className="innertokenimg me-2"
                                                />
                                                {chain.label}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                        <div className="mainqr">
                            <div style={{ position: "relative", width: QrCodeSize, height: QrCodeSize, filter: !aquaSwapAddress ? "blur(4px)" : "none" }}>
                                <QRCodeCanvas
                                    value={aquaSwapAddress ? aquaSwapAddress : ''}
                                    size={QrCodeSize}
                                    bgColor="#ffffff"
                                    fgColor="#000000"
                                    level="H"
                                    includeMargin={true}

                                />
                                <img
                                    src={chainSelected?.icon}
                                    alt={chainSelected?.label}
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        width: UsdtLogoSize,
                                        height: UsdtLogoSize,
                                        transform: "translate(-50%, -50%)",
                                        borderRadius: "50%",
                                        backgroundColor: "#fff",
                                        padding: "4px",
                                    }}
                                />
                            </div>
                        </div>
                        {isBtcSelected &&
                            <div className="option-field">
                                <div className="twice-text">
                                    <label>Refund Wallet Address <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                <h6>Refund Wallet Address</h6>
                                                <p>If this deposit cannot be completed, the funds will be returned to this wallet address. Make sure it is a valid BTC address that you control.</p>
                                            </TooltipCustom>
                                        }
                                    >
                                        <svg style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                            <g clip-path="url(#clip0_11770_8500)">
                                                <path d="M7.5 13.75C10.9518 13.75 13.75 10.9518 13.75 7.5C13.75 4.04822 10.9518 1.25 7.5 1.25C4.04822 1.25 1.25 4.04822 1.25 7.5C1.25 10.9518 4.04822 13.75 7.5 13.75Z" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M7.5 10V7.5" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M7.5 5H7.5075" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_11770_8500">
                                                    <rect width="15" height="15" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </OverlayTrigger></label>
                                    <p>Please pay attention that you provide a BTC address</p>
                                </div>
                                <input type="text" value={btcRefundAddress} onChange={(e) => setBtcRefundAddress(e.target.value)} placeholder="Enter a valid BTC wallet address" />
                            </div>}
                        <p className="orange-text">
                            {`⚠️ This request applies to one swap only and will remain valid for ${convertMsToMin(AQUA_WALLET_TIME_EXPIRE)} minutes. For further swaps, please initiate a new request.`}
                            <br />
                            {`The minimum swap limit is ${minDepositAmount}`}
                        </p>
                        {aquaSwapAddress &&
                            <div className="addressmain">
                                <div className="addresstexts">
                                    <p className="depositpara">{t("Your deposit address:")}</p>
                                    <h6 className="wallethead">
                                        {addressLoading ? t("Generating...") :
                                            `${aquaSwapAddress?.slice(0, 9)}...${aquaSwapAddress?.slice(-5)}`
                                        }
                                    </h6>
                                </div>
                                {isCopied ? <button className="copybtn">
                                    <svg className="copysvg" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M13 3L4.75 11L1 7.36364" stroke="#E6FF00" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button> :
                                    (!addressLoading && <button onClick={() => handleCopy(aquaSwapAddress)} className="copybtn">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                        >
                                            <path
                                                d="M10.6668 8.60004V11.4C10.6668 13.7334 9.7335 14.6667 7.40016 14.6667H4.60016C2.26683 14.6667 1.3335 13.7334 1.3335 11.4V8.60004C1.3335 6.26671 2.26683 5.33337 4.60016 5.33337H7.40016C9.7335 5.33337 10.6668 6.26671 10.6668 8.60004Z"
                                                stroke="#DAD9D9"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M14.6668 4.60004V7.40004C14.6668 9.73337 13.7335 10.6667 11.4002 10.6667H10.6668V8.60004C10.6668 6.26671 9.7335 5.33337 7.40016 5.33337H5.3335V4.60004C5.3335 2.26671 6.26683 1.33337 8.60016 1.33337H11.4002C13.7335 1.33337 14.6668 2.26671 14.6668 4.60004Z"
                                                stroke="#DAD9D9"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </button>)
                                }
                            </div>
                        }
                        {showGenerateButton &&
                            <div className="twice-btns" style={{ gridTemplateColumns: "1fr" }}>
                                <button
                                    className="btn-deposit"
                                    onClick={() => handleShow()}
                                >
                                    {addressLoading ? "Genrating..." : t("Generate Swap Request")}
                                </button>
                            </div>
                        }
                    </Modal.Body>
                    :
                    <Modal.Body>
                        <div className="mainboxes">
                            <div className="innermainbox">
                                <p className="innerpara">{t("Token")}</p>
                                <Dropdown className="dropdown dropdowntokenitems">
                                    <Dropdown.Toggle class="dropdown-toggle" id="dropdown-basic">
                                        <div className="left-item">
                                            <img src={selectedToken === TOKEN_USDT ? "assets/usdticon.png" : "assets/rain-icon.svg"} alt="img" className="img-fluid" />
                                            {selectedToken}
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M12.8667 6.71141L8.32157 10.8778C8.27936 10.9165 8.22923 10.9473 8.17405 10.9682C8.11887 10.9892 8.05973 11 8 11C7.94027 11 7.88113 10.9892 7.82595 10.9682C7.77077 10.9473 7.72064 10.9165 7.67843 10.8778L3.1333 6.71141C3.06967 6.65314 3.02632 6.57888 3.00875 6.49801C2.99119 6.41715 3.00019 6.33333 3.03462 6.25715C3.06905 6.18098 3.12736 6.11589 3.20217 6.07011C3.27698 6.02434 3.36492 5.99994 3.45487 6H12.5451C12.6351 5.99994 12.723 6.02434 12.7978 6.07011C12.8726 6.11589 12.931 6.18098 12.9654 6.25715C12.9998 6.33333 13.0088 6.41715 12.9912 6.49801C12.9737 6.57888 12.9303 6.65314 12.8667 6.71141Z" fill="#212121" />
                                        </svg>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setSelectedToken(TOKEN_USDT)}>
                                            <img src="/assets/usdticon.png" alt="USDT" className="img-fluid" style={{ width: "20px", marginRight: "8px" }} />
                                            {TOKEN_USDT}
                                        </Dropdown.Item>
                                        {/* <Dropdown.Item onClick={() => setSelectedToken(TOKEN_RAIN)}>
                                            <img src="/assets/rain-icon.svg" alt="RAIN" className="img-fluid" style={{ width: "20px", marginRight: "8px" }} />
                                            {TOKEN_RAIN}
                                        </Dropdown.Item> */}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <div className="innermainbox">
                                <p className="innerpara">{t("Chain")}</p>
                                <div className="innerbox">
                                    <div className="tokenimg">
                                        <img src="/assets/navbar/arbitrum.svg" alt="innertokenimg" className="innertokenimg" />
                                    </div>
                                    <p className="tokenpara">{t("Arbitrum")}</p>
                                </div>
                            </div>
                        </div>
                        <div className="mainqr">
                            <div style={{ position: "relative", width: QrCodeSize, height: QrCodeSize }}>
                                <QRCodeCanvas
                                    value={smartAccount}
                                    size={QrCodeSize}
                                    bgColor="#ffffff"
                                    fgColor="#000000"
                                    level="H"
                                    includeMargin={true}
                                />
                                <img
                                    src={selectedToken === TOKEN_USDT ? "/assets/usdticon.png" : "/assets/rain-icon.svg"}
                                    alt={selectedToken}
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        width: UsdtLogoSize,
                                        height: UsdtLogoSize,
                                        transform: "translate(-50%, -50%)",
                                        borderRadius: "50%",
                                        backgroundColor: "#fff",
                                        padding: "4px",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="addressmain">
                            <div className="addresstexts">
                                <p className="depositpara">{t("Your deposit address:")}</p>
                                <h6 className="wallethead">
                                    {smartAccount?.slice(0, 9)}...{smartAccount?.slice(-5)}
                                </h6>
                            </div>
                            {isCopied ? <button className="copybtn">
                                <svg className="copysvg" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M13 3L4.75 11L1 7.36364" stroke="#E6FF00" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button> :
                                <button onClick={() => handleCopy(smartAccount)} className="copybtn">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                    >
                                        <path
                                            d="M10.6668 8.60004V11.4C10.6668 13.7334 9.7335 14.6667 7.40016 14.6667H4.60016C2.26683 14.6667 1.3335 13.7334 1.3335 11.4V8.60004C1.3335 6.26671 2.26683 5.33337 4.60016 5.33337H7.40016C9.7335 5.33337 10.6668 6.26671 10.6668 8.60004Z"
                                            stroke="#DAD9D9"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M14.6668 4.60004V7.40004C14.6668 9.73337 13.7335 10.6667 11.4002 10.6667H10.6668V8.60004C10.6668 6.26671 9.7335 5.33337 7.40016 5.33337H5.3335V4.60004C5.3335 2.26671 6.26683 1.33337 8.60016 1.33337H11.4002C13.7335 1.33337 14.6668 2.26671 14.6668 4.60004Z"
                                            stroke="#DAD9D9"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </button>}
                        </div>
                    </Modal.Body>
                }
            </Modal>
        </>
    )
}

export const DepositViaAccount = ({ show, handleClose, selectedBalance, setSelectedToken, selectedToken, DepositUsdtOrEth, depositAmount, setDepositAmount, isDepositing }) => {
    const { t } = useTranslation();
    useEffect(() => {
        setDepositAmount("");
    }, [selectedToken]);
    return (
        <>

            <Modal
                id="popup-deposit-dialog"
                className="common-modal-style wallet-modal fundmodal"
                show={show}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}
                        onClick={handleClose}
                    ><svg style={{ flexShrink: "0" }} xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                            <path d="M2.41453 9.10172L7.47703 4.03922C7.58258 3.93367 7.72573 3.87437 7.875 3.87437C8.02427 3.87437 8.16742 3.93367 8.27297 4.03922C8.37852 4.14477 8.43781 4.28792 8.43781 4.43719C8.43781 4.58645 8.37852 4.72961 8.27297 4.83515L4.17024 8.93719L15.1875 8.93719C15.3367 8.93719 15.4798 8.99645 15.5852 9.10194C15.6907 9.20743 15.75 9.3505 15.75 9.49969C15.75 9.64887 15.6907 9.79195 15.5852 9.89743C15.4798 10.0029 15.3367 10.0622 15.1875 10.0622L4.17024 10.0622L8.27297 14.1642C8.37852 14.2698 8.43781 14.4129 8.43781 14.5622C8.43781 14.7115 8.37852 14.8546 8.27297 14.9602C8.16742 15.0657 8.02427 15.125 7.875 15.125C7.72573 15.125 7.58258 15.0657 7.47703 14.9602L2.41453 9.89766C2.36223 9.84541 2.32074 9.78338 2.29244 9.71509C2.26413 9.6468 2.24956 9.57361 2.24956 9.49969C2.24956 9.42576 2.26413 9.35257 2.29244 9.28428C2.32074 9.216 2.36223 9.15396 2.41453 9.10172Z" fill="white" />
                        </svg>{t("Via connected wallet")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mainboxes">
                        <div className="innermainbox">
                            <p className="innerpara">{t("Token")}</p>
                            <Dropdown className="dropdown dropdowntokenitems">
                                <Dropdown.Toggle class="dropdown-toggle" id="dropdown-basic">
                                    <div className="left-item">
                                        <img src={selectedToken === TOKEN_USDT ? "assets/usdticon.png" : "assets/rain-icon.svg"} alt="img" className="img-fluid" />
                                        {selectedToken}
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M12.8667 6.71141L8.32157 10.8778C8.27936 10.9165 8.22923 10.9473 8.17405 10.9682C8.11887 10.9892 8.05973 11 8 11C7.94027 11 7.88113 10.9892 7.82595 10.9682C7.77077 10.9473 7.72064 10.9165 7.67843 10.8778L3.1333 6.71141C3.06967 6.65314 3.02632 6.57888 3.00875 6.49801C2.99119 6.41715 3.00019 6.33333 3.03462 6.25715C3.06905 6.18098 3.12736 6.11589 3.20217 6.07011C3.27698 6.02434 3.36492 5.99994 3.45487 6H12.5451C12.6351 5.99994 12.723 6.02434 12.7978 6.07011C12.8726 6.11589 12.931 6.18098 12.9654 6.25715C12.9998 6.33333 13.0088 6.41715 12.9912 6.49801C12.9737 6.57888 12.9303 6.65314 12.8667 6.71141Z" fill="#212121" />
                                    </svg>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => {
                                        setSelectedToken(TOKEN_USDT);
                                    }}>
                                        <img src="/assets/usdticon.png" alt="USDT" className="img-fluid" style={{ width: "20px", marginRight: "8px" }} />
                                        USDT
                                    </Dropdown.Item>
                                    {/* <Dropdown.Item onClick={() => {
                                        setSelectedToken(TOKEN_RAIN);
                                    }}>
                                        <img src="/assets/rain-icon.svg" alt="RAIN" className="img-fluid" style={{ width: "20px", marginRight: "8px" }} />
                                        RAIN
                                    </Dropdown.Item> */}
                                </Dropdown.Menu>

                                {/* <Dropdown.Menu className="dropdown-menu">
                                    <a onClick={setSelectedToken(TOKEN_RAIN)} href="#" className="dropdown-item"><div className="tokenmain"><img src="\assets\usdt-icon-new.svg" alt="img" className="img-fluid tokenmainimg" /> USDT</div></a>
                                    <a onClick={setSelectedToken(TOKEN_USDT)} href="#" className="dropdown-item"><div className="tokenmain"><img src="\assets\rain-icon.svg" alt="img" className="img-fluid tokenmainimg" /> RAIN</div></a>
                                </Dropdown.Menu> */}
                            </Dropdown>
                        </div>
                        <div className="innermainbox">
                            <p className="innerpara">{t("Chain")}</p>
                            <div className="innerbox">
                                <div className="tokenimg">
                                    <img src="/assets/navbar/arbitrum.svg" alt="innertokenimg" className="innertokenimg" />
                                </div>
                                <p className="tokenpara">{t("Arbitrum")}</p>
                            </div>
                        </div>
                    </div>
                    <div className="option-parent">
                        <div className="upper-text">
                            <h6>{t("Amount")}</h6>
                            <h5>
                                {t("Balance")}:
                                <span>
                                    <img src={selectedToken === TOKEN_USDT ? "assets/usdticon.png" : "assets/rain-icon.svg"} />
                                    {Number(selectedBalance ? selectedBalance : 0)?.toFixed(2)} {selectedToken}
                                </span>
                            </h5>
                        </div>
                        <div className="option-field">
                            <input value={depositAmount} onChange={(e) => setDepositAmount(e.target.value)} type="number" placeholder="0.00" />
                            <a onClick={() => {
                                setDepositAmount(selectedBalance);
                            }} className="btn-max">{t("MAX")}</a>
                        </div>
                    </div>
                    <div className="twice-btns">
                        <button onClick={handleClose} className="btn-cancel">{t("Close")}</button>
                        <button
                            id="btn-deposit-deposit"
                            className="btn-deposit"
                            onClick={() => DepositUsdtOrEth()}
                            disabled={isDepositing || !depositAmount || depositAmount === "0"}
                        >
                            {isDepositing ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            ) : (
                                t("Deposit")
                            )}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export const DepositSuccess = ({ show, handleClose, depositAmount, selectedToken, scrollToHistory }) => {
    const { t } = useTranslation();
    const { theme } = useTheme();
    return (
        <Modal className='common-modal-style withdrawmodal' id="popup-deposit-success" show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("Success")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='innercontent'>
                    <div className='uppermain'>
                        {
                            theme === DARK_THEME ? <svg xmlns="http://www.w3.org/2000/svg" width="64" height="65" viewBox="0 0 64 65" fill="none" className='clock'>
                                <rect y="0.5" width="64" height="64" rx="32" fill="#99FF80" />
                                <path d="M48.9056 24.4461L28.4256 44.9261C28.3067 45.0451 28.1656 45.1395 28.0102 45.2039C27.8548 45.2683 27.6882 45.3015 27.52 45.3015C27.3518 45.3015 27.1852 45.2683 27.0298 45.2039C26.8745 45.1395 26.7333 45.0451 26.6144 44.9261L17.6544 35.9661C17.4142 35.7259 17.2793 35.4001 17.2793 35.0605C17.2793 34.7208 17.4142 34.3951 17.6544 34.1549C17.8946 33.9147 18.2203 33.7798 18.56 33.7798C18.8997 33.7798 19.2254 33.9147 19.4656 34.1549L27.52 42.2109L47.0944 22.6349C47.3346 22.3947 47.6603 22.2598 48 22.2598C48.3397 22.2598 48.6654 22.3947 48.9056 22.6349C49.1458 22.8751 49.2807 23.2008 49.2807 23.5405C49.2807 23.8801 49.1458 24.2059 48.9056 24.4461Z" fill="#111111" />
                            </svg> : <img src='\assets\lightcheckmark.svg' alt='img' className='img-fluid tickimg' />
                        }
                        <h6>{t("Deposit Completed!")}</h6>
                        <p className='success-text paraaaa'><span id="deposit-sum"> {depositAmount} {selectedToken === TOKEN_RAIN ? TOKEN_RAIN : TOKEN_USDT}  </span> {t("were successfully deposited to your account")}</p>
                        <button onClick={scrollToHistory} className='back'>{t("View History")}</button>
                    </div>
                </div>
            </Modal.Body>

        </Modal>)
}